import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import {
  Badge,
  Button,
  Col,
  Card,
  CardBody,
  FormGroup,
  Input,
  InputGroup,
  InputGroupButton,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  PaginationItem,
  PaginationLink,
  Row,
  Table
} from 'reactstrap';
import Pagination from '../../components/Pagination';

// Firebase
import { app } from '../../base';

const TableRow = (props) => {
  var status = parseInt(props.data.status) && 1;
  return (
    <tr>
      <td><img src={props.data.image || ''} height="64" width="64" /></td>
      <td>{props.data.name || ''}</td>
      <td>{props.data.category_name}</td>
      <td>{props.data.sub_category || ''}</td>
      <td>{props.data.brand_name || ''}</td>
      <td>{props.data.price || ''}</td>
      <td><Badge color={status?'success':'secondary'} onClick={()=>props.changeStatus(props.rowKey,status)} style={{cursor:'pointer'}}>{status?'Active':'Inactive'}</Badge></td>
      <td align="center">
        <i className="fa fa-pencil fa-lg mr-1 icon-pointer" onClick={()=>props.viewForm(props.rowKey, props.data)}></i>
        <i className="fa fa-remove fa-lg icon-pointer" onClick={()=>props.deleteData(props.rowKey)}></i>
      </td>
    </tr>
  );
}

function ShowMessage(props) {
  return <div className="alert alert-info" role="alert" style={{display:props.show}}>{props.message}</div>;
}

class Inventory extends Component {
  constructor() {
    super();
    let uid = sessionStorage.getItem("uid");
    let user_type = sessionStorage.getItem("user_type");
    let shop_list = '';
    let add_col_size = '9'
    if (user_type == 1) {
      shop_list = 'active';
      add_col_size = '6';
    }
    this.initialData = {
      name: '',
      price: ''
    };

    this.state = {
      add_col_size: add_col_size,
      data: this.initialData,
      modal: false,
      options_shop: [],
      pageOfItems: [],
      products: [],
      rows: [],
      searchRows: [],
      shop_id: null,
      shop_list: shop_list,
      show: 'none',
      uid: uid,
      user_type: user_type
    };

    this.changeStatus = this.changeStatus.bind(this);
    this.deleteData = this.deleteData.bind(this);
    this.onChangePage = this.onChangePage.bind(this);
    this.onShopChange = this.onShopChange.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.viewForm = this.viewForm.bind(this);

    if (user_type == 1) {
      this.createShopOption();
    }
  }

  componentWillMount() {
    this.loadInventory(null);
  }

  changeStatus(key, status){
    let shop_id = this.state.shop_id;
    if (shop_id == null) {
      shop_id = this.state.uid;
    }
    app.database().ref('inventory/'+shop_id+'/'+ key).update({
      status: 1-status
    });
  }

  createShopOption() {
    let result = [];
    app.database().ref('/users').orderByChild('user_type').equalTo(2).once('value', (snapshot)=>{
      snapshot.forEach((child)=>{
        if ((child.val().user_name != '') && (child.val().shop_name !== undefined)) {
          let data = {};
          data.key = child.key;
          data.user_name = child.val().user_name;
          data.shop_name = child.val().shop_name;
          result.push(data);
        }
      });
    })
    .then(()=>{
      let options = [];
      result.sort(function(a,b) {return (a.user_name > b.user_name) ? 1 : ((b.user_name > a.user_name) ? -1 : 0);});
      for (let i = 0, len = result.length; i < len; i++) {
        options.push(<option key={result[i].key} value={result[i].key}>{result[i].user_name+' ('+result[i].shop_name+')'}</option>);
      }
      this.setState({
        options_shop: options
      });
    });
  }

  deleteData(key) {
    if (confirm("Are you sure you want to delete this item?")) {
      let products = this.state.products;
      delete products[key];

      app.database().ref('inventory/'+this.state.uid+'/'+ key).remove()
      .catch((error)=>{
        alert(error.message);
      });
    }
  }

  filterData(searchText, element){
    return (element.props.data.name.toLowerCase().indexOf(searchText) != -1)
  }

  generateRow(products) {
    let rows = [];
    for (let key in products) {
      rows.push(<TableRow key={key} data={products[key]} rowKey={key} changeStatus={this.changeStatus} viewForm={this.viewForm} deleteData={this.deleteData} />);
    }
    this.setState({
      rows:rows,
      searchRows: rows
    });
  }

  loadInventory(shop_id) {
    let products = [], user_type = this.state.user_type;
    if (user_type == 2) {
      products = this.state.products;
      shop_id = this.state.uid;
    }

    if (shop_id != null) {
      app.database().ref('inventory/'+shop_id).on('value', (snapshot)=>{
        let inventory, len = Object.keys(products).length, price, status;

        inventory = [], price = [], status = [];
        snapshot.forEach((child)=>{
          if (len == 0 || user_type == 1) {
            inventory.push(child.key);
            price.push(child.val().price);
            status.push(child.val().status);
          }
          else {
            products[child.key].price = child.val().price;
            products[child.key].status = child.val().status;
          }
        });

        if (len == 0 || user_type == 1) {
          app.database().ref('/products').orderByChild('name').once('value', (snapshot)=>{
            let idx = -1;
            snapshot.forEach((child)=>{
              idx = inventory.indexOf(child.key);
              if (idx != -1) {
                let data = child.val();
                data.price = price[idx];
                data.status = status[idx];
                products[child.key] = data;
              }
            });
            this.setState({
              products: products
            });
          }).then(()=>{
            this.generateRow(products);
          });
        }
        else {
          this.generateRow(products);
        }
      });
    }
  }

  onChangePage(pageOfItems) {
    // update state with new page of items
    this.setState({ pageOfItems: pageOfItems });
  }

  onSearch(event) {
    event.preventDefault()

    const searchText = this.searchInput.value

    if (this.state.searchRows.length == 0) return;

    var rows = this.state.searchRows.filter(this.filterData.bind(this, searchText));
    this.setState({rows:rows});
  }

  onShopChange(event) {
    let shop_id = event.target.value;
    if (shop_id == '') {
      this.setState({
        rows: [],
        searchRows: []
      });
    }
    else {
      this.setState({
        shop_id: shop_id
      });
      this.loadInventory(shop_id);
    }
  }

  render() {
    return (
      <div className="animated fadeIn">
        <Row>
          <Col>
            <Card>
              <CardBody>
              <FormGroup row>
                {
                  (this.state.shop_list == 'active') &&
                  <Col md="3">
                    <InputGroup className="mb-3">
                      <Input type="select" name="shop_list" innerRef={(input) => { this.shopInput = input }} onChange={this.onShopChange}>
                        <option value="">Select Shop</option>
                        {this.state.options_shop}
                      </Input>
                    </InputGroup>
                  </Col>
                }
                <Col md="3">
                  <form onSubmit={(event) => { this.onSearch(event) }} ref={(form) => { this.searchForm = form }}>
                    <InputGroup>
                      <Input size="10" type="text" placeholder="Enter text here" innerRef={(input) => { this.searchInput = input }}/>
                      <InputGroupButton>
                        <Button color="info">Search</Button>
                      </InputGroupButton>
                    </InputGroup>
                  </form>
                </Col>
                <Col md={this.state.add_col_size}>
                  <Link to={`/add-inventory`}><Button className="float-right" color="primary"><i className="fa fa-plus"></i>{'\u00A0'} Add</Button></Link>
                </Col>
                </FormGroup>
                <Table bordered striped responsive size="sm">
                  <thead>
                  <tr>
                    <th>Image</th>
                    <th>Name</th>
                    <th>Category</th>
                    <th>Sub Category</th>
                    <th>Brand</th>
                    <th>Price</th>
                    <th>Status</th>
                    <th className="text-center">Action</th>
                  </tr>
                  </thead>
                  <tbody>{this.state.pageOfItems}</tbody>
                </Table>
                <nav>
                  <Pagination items={this.state.rows} onChangePage={this.onChangePage} />
                </nav>
                <Modal isOpen={this.state.modal} toggle={this.toggleModal} className='modal-lg'>
                  <form onSubmit={(event) => { this.updateData(event) }} ref={(form) => { this.editForm = form }}>
                    <ModalHeader toggle={this.toggleModal}>
                      <ShowMessage show={this.state.show} message={this.state.message} />
                    </ModalHeader>
                    <ModalBody>
                      <Label>{this.state.data.name+' ('+this.state.data.brand_name+')'}</Label>
                      <InputGroup className="mb-3">
                        <Input type="text" innerRef={(input) => { this.priceInput = input }} defaultValue={this.state.data.price} required />
                      </InputGroup>
                    </ModalBody>
                    <ModalFooter>
                      <Button color="primary">Update</Button>{' '}
                      <Button color="secondary" onClick={this.toggleModal}>Cancel</Button>
                    </ModalFooter>
                  </form>
                </Modal>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    )
  }

  setMessage(msg) {
    this.setState({
      message: msg,
      show: ''
    });
  }

  toggleModal() {
    this.setState({
      modal: !this.state.modal
    });
  }

  updateData(event) {
    event.preventDefault()
    
    const price = this.priceInput.value

    if (price == '') {
      this.setMessage('Price field can not be empty');
      return;
    }

    let shop_id = this.state.shop_id;
    if (shop_id == null) {
      shop_id = this.state.uid;
    }

    app.database().ref('inventory/'+shop_id+'/'+this.state.key).update({
      price: price
    }).then(()=>{
      this.setState({
        modal: !this.state.modal
      });
    }).catch((error)=>{
      this.setMessage(error.message);
    });
  }

  viewForm(key, data) {
    this.setState({
      data: data,
      key: key,
      message: '',
      modal: !this.state.modal,
      show: 'none'
    });
  }
}

export default Inventory;


// WEBPACK FOOTER //
// ./src/views/Inventory/Inventory.js